import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuditRoutingModule } from './audit-routing.module';
import { AuditComponent } from './audit.component';
import { SharedModule } from '../../../../aop-eop-core/src/app/shared/shared.module';
import { AuditSiteOverviewComponent } from '../audit-site-overview/audit-site-overview.component';
import { SelfAuditSiteOverviewComponent } from '../self-audit-site-overview/self-audit-site-overview.component';
import { AuditSocioEconomicDataCardComponent } from '../audit-socio-economic-data-card/audit-socio-economic-data-card.component';
import { AuditLoadPointDistributionComponent } from '../audit-load-point-distribution/audit-load-point-distribution.component';
import {LoadPointOverviewComponent} from "../load-point-overview/load-point-overview.component";
import { AuditReportComponent } from '../audit-report/audit-report.component';
import {GoogleMapsModule} from "@angular/google-maps";
import {UpdateSiteDetailsComponent} from "../update-site-details/update-site-details.component";

@NgModule({
  declarations: [
    AuditComponent,
    AuditSiteOverviewComponent,
    SelfAuditSiteOverviewComponent,
    AuditSocioEconomicDataCardComponent,
    AuditLoadPointDistributionComponent,
    LoadPointOverviewComponent,
    AuditReportComponent,
    UpdateSiteDetailsComponent,
  ],
  imports: [
    CommonModule,
    AuditRoutingModule,
    SharedModule,
    ...SharedModule.sharedRootModules(),
    GoogleMapsModule,
  ],
})
export class AuditModule {}
